import { render } from "./SelectPromoCode.vue?vue&type=template&id=628fa4ad"
import script from "./SelectPromoCode.vue?vue&type=script&lang=js"
export * from "./SelectPromoCode.vue?vue&type=script&lang=js"

import "./SelectPromoCode.vue?vue&type=style&index=0&id=628fa4ad&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__